module.exports = __webpack_public_path__ + "static/media/pic2.e7756f13.jpg";